import React from 'react';
import { MenuTemplate } from 'themes/components';
import { inject, observer } from 'mobx-react';

@inject(i => ({
	menuStore: i.rootStore.menuStore,
}))
class BaasicMenu extends React.Component {
	render() {
		return <MenuTemplate {...this.props} />;
	}
}

export default BaasicMenu;
